import React, { useState } from 'react';
import { galleryImages } from '../data/mockData';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'Todos' },
    { id: 'proyectos', label: 'Proyectos' },
    { id: 'capacitaciones', label: 'Capacitaciones' },
    { id: 'servicios', label: 'Servicios' },
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <section id="galeria" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-block mb-4">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider bg-orange-100 px-4 py-2 rounded-full">
              Galería
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nuestro Trabajo
            <span className="text-orange-600"> en Acción</span>
          </h2>
          <p className="text-lg text-gray-600">
            Explora algunos de nuestros proyectos, capacitaciones y certificaciones más destacados.
          </p>
        </div>

        {/* Filtros */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all ${
                selectedCategory === category.id
                  ? 'bg-orange-600 text-white shadow-lg scale-105'
                  : 'bg-gray-100 text-gray-700 hover:bg-orange-50 hover:text-orange-600'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Grid de imágenes */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer bg-gray-100"
              style={{ 
                animationDelay: `${index * 0.1}s`,
                minHeight: '300px'
              }}
            >
              {/* Imagen */}
              <img
                src={image.image}
                alt={image.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />

              {/* Overlay con información */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="inline-block mb-2">
                    <span className="text-orange-400 text-xs font-semibold uppercase tracking-wider bg-orange-600/30 px-3 py-1 rounded-full">
                      {categories.find(cat => cat.id === image.category)?.label || image.category}
                    </span>
                  </div>
                  <h3 className="text-white text-xl font-bold">
                    {image.title}
                  </h3>
                </div>
              </div>

              {/* Indicador de zoom */}
              <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {/* Más imágenes disponibles mensaje */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            ¿Quieres ver más proyectos y conocer nuestro trabajo en detalle?
          </p>
          <button
            onClick={() => {
              const contactSection = document.getElementById('contacto');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="text-orange-600 font-semibold hover:text-orange-700 transition-colors inline-flex items-center gap-2"
          >
            Contáctanos para más información
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
